import Container from '@components/container'
import {
  StyleAuthActionWrapper,
  StyleAuthRow,
  StyleAuthWrapper,
} from '../style'
import AuthBanner from '../components/banner'
import AuthHeader from '../components/header'
import Typography from '@components/typography'
import Column from '@components/column'
import Fields from '@components/fields'
import { AuthSchema } from '@validations'
import { Formik, Form } from 'formik'
import { useNavigate } from 'react-router-dom'
import Button from '../../../components/button'
import AuthFooter from '../components/footer'
import SeoHead from '@pages/front/shared/SeoHead/SeoHead'
import { useSeoData } from '@pages/front/hook/useSeoData'
const RolePage = () => {
  const navigate = useNavigate()
  const submitHandler = async (values) => {
    navigate('/phone', {
      state: {
        role: values?.role,
        purpose: 'Register',
      },
    })
  }
  const seo = useSeoData('register-seo', 'RegisterSeo')
  return (
    <>
      <SeoHead seo={seo} />
      <StyleAuthWrapper>
        <Container>
          <StyleAuthRow>
            <AuthBanner />
            <StyleAuthActionWrapper>
              <AuthHeader
                title="Register as Provider with"
                tag="Supachar"
                subTitle="Connecting You to What Matters"
              />
              <Column
                justifyContent="center"
                alignItems="center"
                styleColumn="margin-bottom:20px;"
              >
                <Typography content="Select Role" size={18} />
              </Column>
              <Formik
                initialValues={{
                  role: '',
                }}
                onSubmit={submitHandler}
                validationSchema={AuthSchema.roleValidationSchema}
              >
                {({ handleSubmit }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Fields.ChooseBox
                        name="role"
                        items={[
                          {
                            label: 'As Doctor',
                            value: 'doctor',
                            description:
                              'Licensed medical practitioners, specialists & consultants — start your journey with us.',
                            icon: 'doctor',
                          },
                          {
                            label: 'As Medical Institution',
                            value: 'institution',
                            description:
                              'Hospitals, diagnostic labs, clinics & care facilities — start your journey with us.',
                            icon: 'institution',
                          },
                        ]}
                      />
                      <Column styleColumn="margin-top:30px;margin-bottom:20px;">
                        <Button
                          type="submit"
                          title="Submit"
                          styleButton="width:100%;"
                          height={40}
                        />
                      </Column>
                      <AuthFooter
                        title="Already have a Account?"
                        linkTitle="Login Now"
                        to="/login"
                      />
                    </Form>
                  )
                }}
              </Formik>
            </StyleAuthActionWrapper>
          </StyleAuthRow>
        </Container>
      </StyleAuthWrapper>
    </>
  )
}

export default RolePage
